import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { IGenericCardProps, PrivacySettingsCard } from '@gik/inkind-page';

export const textMessagesCardBlockName = 'text-messages-card';

const TextMessagesCard: React.FC<PropsWithClassName<IGenericCardProps>> = ({
  className,
  value,
  onChange,
  inputName,
}): JSX.Element => {
  const { t } = useTranslation();
  const bem = bemBlock(textMessagesCardBlockName);

  return (
    <PrivacySettingsCard
      className={bem(null, null, className)}
      title={t(translationKeys.textMessagesTitle)}
      icon={{
        set: 'gik-icons',
        name: value ? 'TextMessagesOkOutline' : 'TextMessagesDisabledOutline',
      }}
      description={
        value ? t(translationKeys.textMessagesDescription) : t(translationKeys.textMessagesDescriptionDisabled)
      }
      value={value}
      onChange={onChange}
      inputName={inputName}
    />
  );
};

export default TextMessagesCard;
